import { createAction } from 'redux-actions';
import { toast } from 'react-toastify';
import api from '../../utils/api/apiClient';

export const fetchStoreProductsRequest = createAction('FETCH_STORE_PRODUCTS_REQUEST');
export const fetchStoreProductsSuccess = createAction('FETCH_STORE_PRODUCTS_SUCCESS');
export const fetchStoreProductsError = createAction('FETCH_STORE_PRODUCTS_ERROR');

export const registerStoreProductRequest = createAction('REGISTER_STORE_PRODUCT_REQUEST');
export const registerStoreProductSuccess = createAction('REGISTER_STORE_PRODUCT_SUCCESS');
export const registerStoreProductError = createAction('REGISTER_STORE_PRODUCT_ERROR');

export const executeAppStoreStepRequest = createAction('EXECUTE_APP_STORE_STEP_REQUEST');
export const executeAppStoreStepSuccess = createAction('EXECUTE_APP_STORE_STEP_SUCCESS');
export const executeAppStoreStepError = createAction('EXECUTE_APP_STORE_STEP_ERROR');

export const lookupAppStoreIAPRequest = createAction('LOOKUP_APP_STORE_IAP_REQUEST');
export const lookupAppStoreIAPSuccess = createAction('LOOKUP_APP_STORE_IAP_SUCCESS');
export const lookupAppStoreIAPError = createAction('LOOKUP_APP_STORE_IAP_ERROR');

export const deleteAppStoreScreenshotRequest = createAction('DELETE_APP_STORE_SCREENSHOT_REQUEST');
export const deleteAppStoreScreenshotSuccess = createAction('DELETE_APP_STORE_SCREENSHOT_SUCCESS');
export const deleteAppStoreScreenshotError = createAction('DELETE_APP_STORE_SCREENSHOT_ERROR');

const getErrorMessage = (error) => {
    return error?.response?.data?.message || error?.message || 'Error desconocido';
};

export const getCourseStoreProducts = (courseId) => async (dispatch) => {
    dispatch(fetchStoreProductsRequest());
    try {
        const { data } = await api.courseStoreProduct.getCourseStoreProducts({
            course_id: courseId,
            page_size: 100,
        });
        dispatch(fetchStoreProductsSuccess(data.results || []));
    } catch (error) {
        dispatch(fetchStoreProductsError(getErrorMessage(error)));
    }
};

export const registerCourseStoreProduct = (body) => async (dispatch) => {
    dispatch(registerStoreProductRequest(body.store));
    try {
        const { data } = await api.courseStoreProduct.registerCourseStoreProduct(body);
        dispatch(registerStoreProductSuccess(data));
        if (data.status === 'SUCCESS') {
            toast.success('Registrado en Google Play exitosamente');
        } else {
            toast.error(`Error al registrar: ${data.error_message}`);
        }
    } catch (error) {
        dispatch(registerStoreProductError(body.store));
        toast.error(getErrorMessage(error));
    }
};

const refreshStoreProducts = async (dispatch, courseId) => {
    try {
        const { data } = await api.courseStoreProduct.getCourseStoreProducts({
            course_id: courseId,
            page_size: 100,
        });
        dispatch(fetchStoreProductsSuccess(data.results || []));
    } catch { /* silent */ }
};

export const lookupAppStoreIAP = (courseId) => async (dispatch) => {
    dispatch(lookupAppStoreIAPRequest());
    try {
        const { data } = await api.courseStoreProduct.lookupAppStoreIAP(courseId);
        dispatch(lookupAppStoreIAPSuccess(data));
        await refreshStoreProducts(dispatch, courseId);
        toast.success(`IAP vinculado: ${data.name || data.product_id} (${data.status})`);
    } catch (error) {
        dispatch(lookupAppStoreIAPError());
        const responseStatus = error?.response?.status;
        if (responseStatus === 404) {
            toast.warning('No se encontró un IAP en Apple para este productId.');
        } else {
            toast.error(getErrorMessage(error));
        }
    }
};

export const deleteAppStoreScreenshot = (courseId) => async (dispatch) => {
    dispatch(deleteAppStoreScreenshotRequest());
    try {
        await api.courseStoreProduct.deleteAppStoreScreenshot(courseId);
        dispatch(deleteAppStoreScreenshotSuccess());
        await refreshStoreProducts(dispatch, courseId);
        toast.success('Screenshot eliminado exitosamente');
    } catch (error) {
        dispatch(deleteAppStoreScreenshotError());
        toast.error(getErrorMessage(error));
    }
};

export const executeAppStoreStep = (courseId, step, file) => async (dispatch) => {
    dispatch(executeAppStoreStepRequest({ courseId, step }));
    try {
        let response;
        if (step === 'UPLOAD_SCREENSHOT') {
            response = await api.courseStoreProduct.executeAppStoreScreenshotStep(courseId, file);
        } else {
            response = await api.courseStoreProduct.executeAppStoreStep({ course_id: courseId, step });
        }
        const { data } = response;
        dispatch(executeAppStoreStepSuccess({ courseId, step: data }));
        await refreshStoreProducts(dispatch, courseId);
        if (data.status === 'SUCCESS') {
            toast.success(`Paso "${step}" completado exitosamente`);
        } else {
            toast.error(`Error en paso "${step}". Ver detalle en el modal.`);
        }
    } catch (error) {
        dispatch(executeAppStoreStepError({ courseId, step }));
        await refreshStoreProducts(dispatch, courseId);
        toast.error(getErrorMessage(error));
    }
};
